import React from 'react';
import {GridBooleanCell, GridInputCell} from 'core/components';
function resolveColumns(columns){
   columns.forEach(col=>{
       if(col.cell && col.cell === GridBooleanCell){
           const cell = (props)=><GridBooleanCell {...props} {...col.cellProps} {...col}/>
           col.cell = cell;
        }
       if(col.cell && col.cell === GridInputCell){
            const cell = (props)=><GridInputCell {...props} {...col.cellProps} {...col}/>
            col.cell = cell;
        }
   });
   return columns;
}
export{
   resolveColumns
}